'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var PASSWORD_CHANGE_INITIALISED = exports.PASSWORD_CHANGE_INITIALISED = 'PASSWORD_CHANGE_INITIALISED';
var PASSWORD_CHANGE_CODE_EXPIRED = exports.PASSWORD_CHANGE_CODE_EXPIRED = 'PASSWORD_CHANGE_CODE_EXPIRED';
var PASSWORD_CHANGED = exports.PASSWORD_CHANGED = 'PASSWORD_CHANGED';
var PASSWORD_CHANGE_FAILED = exports.PASSWORD_CHANGE_FAILED = 'PASSWORD_CHANGE_FAILED';


//////////////////
// WEBPACK FOOTER
// ./src/client/auth/modals/changePassword/changePasswordConstants.js
// module id = 670
// module chunks = 0